
const Facebook = () => {
	return (
		<svg
			fill="none"
			height="20"
			viewBox="0 0 21 20"
			width="21"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21 10.0607C21 4.50389 16.5225 -0.000793457 10.9994 -0.000793457C5.47619 -0.000793457 0.998779 4.50389 0.998779 10.0607C0.998779 15.0827 4.65585 19.2452 9.43677 20V12.9691H6.89756V10.0607H9.43677V7.84404C9.43677 5.32237 10.9298 3.92948 13.2141 3.92948C14.3083 3.92948 15.4528 4.126 15.4528 4.126V6.60207H14.1917C12.9494 6.60207 12.562 7.37765 12.562 8.17334V10.0607H15.3356L14.8922 12.9691H12.562V20C17.3429 19.2452 21 15.0827 21 10.0607Z"
				fill="#1977F2"
			/>
		</svg>
	);
};

export default Facebook;
